import { cn } from '@/shared/lib/utils'

/** The suite mark, shared by every Lithos application. */
export function Logo({ className }: { className?: string }) {
  return (
    <img
      src="/favicon.svg"
      alt=""
      draggable={false}
      className={cn('shrink-0', className)}
    />
  )
}
